{
  "version": 1,
  "asset_id": "fa63c27d-e115-40bd-819a-5de17aebca1f",
  "project_id": "8cc9b1c1-0457-40cd-aa82-ea9e6032ce50",
  "url": "/__l5e/assets-v1/fa63c27d-e115-40bd-819a-5de17aebca1f/venue-pool-stained-glass.webp",
  "r2_key": "a/v1/8cc9b1c1-0457-40cd-aa82-ea9e6032ce50/fa63c27d-e115-40bd-819a-5de17aebca1f/venue-pool-stained-glass.webp",
  "original_filename": "venue-pool-stained-glass.webp",
  "size": 244524,
  "content_type": "image/webp",
  "created_at": "2026-07-04T16:13:23Z"
}
